import { useState } from 'react';
import type { ClientGateways } from '../gateway/index.ts';
import { LOCALE_CATALOGUE, LOCALES, useI18n, type LocaleCode } from '../i18n/index.ts';

interface Props {
  gw: ClientGateways;
  locale: LocaleCode;
  setLocale: (l: LocaleCode) => void;
  muted: boolean;
  setMuted: (m: boolean) => void;
  reducedMotion: boolean;
}

export function SettingsPanel({ gw, locale, setLocale, muted, setMuted, reducedMotion }: Props) {
  const { t } = useI18n();
  const [msg, setMsg] = useState<string | null>(null);
  return (
    <div className="settings">
      <fieldset>
        <legend>{t('settings.language')}</legend>
        {LOCALES.map((l) => (
          <label key={l.code} className="radio-row">
            <input type="radio" name="locale" checked={locale === l.code} onChange={() => setLocale(l.code as LocaleCode)} /> {l.label}
          </label>
        ))}
        <p className="note">{t('settings.moreLocales', { n: LOCALE_CATALOGUE.length - LOCALES.length })}</p>
      </fieldset>
      <fieldset>
        <legend>{t('settings.sound')}</legend>
        <label className="radio-row">
          <input type="radio" name="sound" checked={muted} onChange={() => setMuted(true)} /> {t('settings.soundOff')}
        </label>
        <label className="radio-row">
          <input type="radio" name="sound" checked={!muted} onChange={() => setMuted(false)} /> {t('settings.soundOn')}
        </label>
      </fieldset>
      <p className="note">{t('settings.motion', { state: reducedMotion ? t('settings.motionOn') : t('settings.motionOff') })}</p>
      {gw.demoData && (
        <div className="reset">
          <p className="note">{t('history.persisted')}</p>
          {gw.demoData.savedAt() && <p className="note">{t('settings.savedAt', { t: gw.demoData.savedAt()! })}</p>}
          <button type="button" className="ghost-btn bordered" onClick={() => gw.demoData!.clear()}>
            {t('settings.clearDemo')}
          </button>
          <p className="note">{t('settings.clearDemoHint')}</p>
        </div>
      )}
      {gw.wallet.resetDemoBalance && (
        <div className="reset">
          <button
            type="button"
            className="ghost-btn"
            onClick={() =>
              void gw.wallet.resetDemoBalance!().then((r) => setMsg(r.ok ? t('settings.resetDone') : t('settings.resetBlocked')))
            }
          >
            {t('settings.resetDemo')}
          </button>
          <p className="note">{t('settings.resetDemoHint')}</p>
          {msg && <p role="status">{msg}</p>}
        </div>
      )}
    </div>
  );
}
